/*eslint no-useless-escape: "off"*/
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { Form, Scope } from "informed";
import firebase from "firebase/app";
import * as constants from "../../../constants";
import { TextInput, SelectInput } from "../../shared/Forms";
import ThemeTemplatePicker from "../../shared/ThemeTemplatePicker";
import * as lookupsActions from "../../../actions/lookupsActions";
import * as appsActions from "../../../actions/appsActions";
import SAMPLE_PAGE from "./samplePage";

class OnBoarding extends Component {
	constructor(props) {
		super(props);
		this.state = {
			content: {},
			step: 0,
			appAdded: false,
			themeAdded: false,
			experienceAdded: false,
			pageAdded: false,
			formApi: undefined,
			appKey: undefined,
			appKeyValid: false,
			showExperiences: false,
			experienceCount: 1,
		};
		this.appKeyDebouncer = null;
	}

	componentDidMount() {
		setTimeout(() => {
			this.setState({ step: 1 });
		}, 500);
		this.props.lookupsActions.getCultures();
	}

	upsertContent = (key, data) => {
		let content = Object.assign({}, this.state.content, { [key]: data });
		this.setState({ content, step: this.state.step + 1 });
	};

	backUp = step => {
		this.setState({ step });
	};

	onSubmitApp = values => {
		if (this.state.appKeyValid) {
			values.key = values.key.replace("https://verrisapp.com/apps/", "");
			this.upsertContent("app", values);
		} else {
			this.state.formApi.setError("key", "This app name already exists");
		}
	};

	skipExperiences = () => {
		this.onSubmitExperience(Object.assign({}, { experiences: [{ name: "Default Experience", culture: "en-US" }] }));
	};

	onSubmitExperience = values => {
		this.upsertContent("experience", values);
	};

	buildApp = () => {
		const { user } = this.props;
		const { content } = this.state;
		this.setState({ step: 5 });
		let pageCount = content.experience.experiences.length;
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});

				api.post("/apps", Object.assign({}, content.app))
					.then(appData => {
						this.setState({ appAdded: true });
						let appId = appData.data.id;
						let appKey = appData.data.key;
						let themeBody = Object.assign({}, content.theme, { name: `${content.app.name} Theme`, appId });
						api.post("/themes", themeBody)
							.then(themeData => {
								this.setState({ themeAdded: true });
								let themeId = themeData.data.id;
								api.put(`/apps/${appId}`, Object.assign({}, content.app, { primaryThemeId: themeId }));

								content.experience.experiences.forEach(experience => {
									let experienceBody = Object.assign({}, experience, { appId });
									api.post("/experiences", experienceBody)
										.then(experienceData => {
											let experienceId = experienceData.data.id;
											this.setState({ experienceAdded: true });
											let newPage = Object.assign({}, SAMPLE_PAGE, {
												themeId,
												experienceId,
											});
											api.post("/pages", newPage)
												.then(pageData => {
													let pageId = pageData.data.id;
													let appNav = {
														title: `${content.app.name} Navigation`,
														themeId,
														forceSelection: true,
														experiences: [
															{
																experienceId,
																title: experience.name,
															},
														],
													};
													let experienceNav = {
														title: `${experience.name} Navigation`,
														themeId,
														kind: "sideMenu",
														pages: [
															{
																pageId,
																title: "My First Page",
															},
														],
													};
													api.put(`/apps/${appId}/navigation`, appNav)
														.then(() => {
															api.put(
																`/experiences/${experienceId}/navigation`,
																experienceNav
															)
																.then(() => {
																	pageCount--;
																	if (pageCount <= 0) {
																		this.setState({
																			step: 6,
																			pageAdded: true,
																			appKey,
																		});
																		this.props.appsActions.loadApps();
																	}
																})
																.catch(experienceNavError => {
																	console.log(experienceNavError);
																});
														})
														.catch(appNavError => {
															console.log(appNavError);
														});
												})
												.catch(pageError => {
													console.log(pageError);
												});
										})
										.catch(experiencError => {
											console.log(experiencError);
											this.rollback(api, appId, themeId);
										});
								});
							})
							.catch(themeError => {
								console.log(themeError);
								this.rollback(api, appId);
							});
					})
					.catch(appError => {
						console.log(appError);
					});
			});
	};

	rollback = (api, appId = null, themeId = null, experienceId = null, pageId = null) => {
		if (themeId) {
			api.delete(`/themes/${themeId}`);
		}
		if (appId) {
			api.delete(`/apps/${appId}`);
		}
	};

	checkAppKey = key => {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/apps/${key.toLowerCase()}/exists`).then(result => {
					this.state.formApi.setError("key", result.data === true ? "This app name already exists" : null);
					this.setState({ appKeyValid: !result.data });
				});
			});
	};

	setAppKey = name => {
		if (this.state.formApi && name) {
			let key = name;
			const ENTITY_NAME_REPLACE_DASH = /[\/\:\=\|\@\+\~\& \-_]+/gi; // FOR TESTING: A’B~C@D!E$F%G&H(I)J[K]L/M\N+O,P.Q?R”S:T;U{V}W|X=Y_Z#1^2*3<4>5`6-7 8
			const ENTITY_NAME_REPLACE_BLANK = /[^A-Za-z0-9\-]+/gi;

			key = key.replace(ENTITY_NAME_REPLACE_DASH, "-");
			key = key.replace(ENTITY_NAME_REPLACE_BLANK, "");
			this.state.formApi.setValue("key", `https://verrisapp.com/apps/${key.toLowerCase()}`);
			if (this.appKeyDebouncer) {
				clearTimeout(this.appKeyDebouncer);
			}
			this.appKeyDebouncer = setTimeout(() => {
				this.checkAppKey(key.toLowerCase());
				this.appKeyDebouncer = null;
			}, 200);
		} else if (this.state.formApi) {
			this.state.formApi.setValue("key", "https://verrisapp.com/apps/");
		}
	};

	setFormApi = formApi => {
		this.setState({ formApi });
	};

	renderAppBuilder = () => {
		return (
			<div className="on-boarding-wrap">
				<Form onSubmit={this.onSubmitApp} getApi={this.setFormApi}>
					<button className="on-boarding-btn forward" type="submit">
						<i className="fal fa-chevron-right"></i>
					</button>
					<div className="on-boarding-box box">
						<h3 className="page-title">{"Let's Build An App"}</h3>
						<TextInput
							field="name"
							id="name"
							placeholder="Name"
							autocomplete="off"
							isRequired={true}
							minLength={2}
							maxLength={30}
							onValueChange={this.setAppKey}
							validationRegex={constants.APP_NAME}
							regexMessage="Please add a valid app name"
						/>
						<TextInput
							field="key"
							id="key"
							placeholder="App Key"
							autocomplete="off"
							isRequired={true}
							minLength={3}
							maxLength={50}
							regexMessage="Please add a valid app key"
							disabled={true}
						/>
					</div>
				</Form>
			</div>
		);
	};
	pickTheme = theme => {
		this.upsertContent("theme", theme);
	};
	renderThemeBuilder = () => {
		return (
			<div className="on-boarding-wrap">
				<button
					className="on-boarding-btn back"
					onClick={() => {
						this.backUp(1);
					}}
				>
					<i className="fal fa-chevron-left"></i>
				</button>
				<div className="on-boarding-box box">
					<h3 className="page-title">{"Let's Pick A Theme"}</h3>
					<h4>{"We'll make this our own later"}</h4>
					<ThemeTemplatePicker pickTheme={this.pickTheme} />
				</div>
			</div>
		);
	};

	removeExperience = index => {
		let { expFormApi, experienceCount } = this.state;
		var values = Object.assign({}, expFormApi.getState().values);
		values.experiences.splice(index, 1);
		expFormApi.setValues(values);
		this.setState({ experienceCount: experienceCount - 1 });
	};

	renderExperienceBuilder = () => {
		const { cultures } = this.props;
		let data = [];
		if (cultures) {
			cultures.forEach(culture => {
				data.push({ key: culture.code, value: culture.code, label: culture.name });
			});
		}

		let inputs = [];
		for (var i = 0; i < this.state.experienceCount; i++) {
			let index = i;
			inputs.push(
				<Scope scope={`experiences[${i}]`}>
					{i > 0 && <div className="divider"></div>}
					{this.state.experienceCount > 1 && (
						<div style={{ height: "20px" }}>
							<div className="btn-circle m-right" onClick={() => this.removeExperience(index)}>
								<i className="fal fa-times icon"></i>
							</div>
						</div>
					)}
					<TextInput
						field="name"
						id="name"
						placeholder="Name"
						autocomplete="off"
						isRequired={true}
						tabIndex={-1}
					/>
					{data.length > 0 && (
						<SelectInput
							field="culture"
							id="culture"
							values={data}
							placeholder="Culture"
							isRequired={true}
							initialValue="en-US"
							tabIndex={-1}
						/>
					)}
				</Scope>
			);
		}

		return (
			<div className="on-boarding-wrap">
				<Form
					onSubmit={this.onSubmitExperience}
					initialValues={{ experiences: [{ culture: "en-US" }] }}
					getApi={formApi => {
						this.setState({ expFormApi: formApi });
					}}
				>
					<button
						className="on-boarding-btn back"
						onClick={() => {
							this.backUp(2);
						}}
					>
						<i className="fal fa-chevron-left"></i>
					</button>
					<button className="on-boarding-btn forward" type="submit">
						<i className="fal fa-chevron-right"></i>
					</button>
					<div className="on-boarding-box box">
						<div className="giant-icon">
							<i className="fal fa-mobile"></i>
						</div>
						<div>
							{this.state.showExperiences && (
								<div
									className="btn-circle m-right"
									onClick={() => this.setState({ experienceCount: this.state.experienceCount + 1 })}
								>
									<i className="fal fa-plus icon"></i>
								</div>
							)}
							<h3 className="page-title">{"Experiences"}</h3>
						</div>
						{this.state.showExperiences ? (
							<div>{inputs}</div>
						) : (
							<div>
								<div className="m-bottom">
									{
										"Partition your app into experiences to provide specific content for each of your audiences. Your users can pick an experience, such as event location or church campus, and see curated content related to their choice."
									}
								</div>
								<div
									className="btn btn-primary wide"
									onClick={() => this.setState({ showExperiences: true })}
								>
									Set Up Experiences
								</div>
								<a className="p-top m-top" style={{ display: "block" }} onClick={this.skipExperiences}>
									Skip For Now
								</a>
							</div>
						)}
					</div>
				</Form>
			</div>
		);
	};

	renderFinish = () => {
		return (
			<div className="on-boarding-wrap">
				<button
					className="on-boarding-btn back"
					onClick={() => {
						this.backUp(3);
					}}
				>
					<i className="fal fa-chevron-left"></i>
				</button>
				<div className="on-boarding-box box">
					<h3 className="page-title">{"Ready To Finish?"}</h3>

					<div className="btn btn-primary" onClick={() => this.buildApp()}>
						{"Let's Do This"}
					</div>
				</div>
			</div>
		);
	};

	renderChecklist = () => {
		const { appAdded, themeAdded, experienceAdded, pageAdded } = this.state;
		return (
			<div className="on-boarding-wrap">
				<div className="on-boarding-box box">
					<h3 className="page-title">{"We're Getting Things Set Up:"}</h3>
					<div>
						<div className={`on-boarding-checkmark ${appAdded ? "on" : ""}`}>
							<i className="fal fa-check"></i>
						</div>
						<div className="on-boarding-label on">Setting Up Your App</div>
					</div>
					<div>
						<div className={`on-boarding-checkmark ${themeAdded ? "on" : ""}`}>
							<i className="fal fa-check"></i>
						</div>
						<div className={`on-boarding-label ${appAdded ? "on" : ""}`}>Applying Your Theme</div>
					</div>
					<div>
						<div className={`on-boarding-checkmark ${experienceAdded ? "on" : ""}`}>
							<i className="fal fa-check"></i>
						</div>
						<div className={`on-boarding-label ${themeAdded ? "on" : ""}`}>Adding Your Experience</div>
					</div>
					<div>
						<div className={`on-boarding-checkmark ${pageAdded ? "on" : ""}`}>
							<i className="fal fa-check"></i>
						</div>
						<div className={`on-boarding-label ${experienceAdded ? "on" : ""}`}>
							Building Your First Page
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderDone = () => {
		return (
			<div className="on-boarding-wrap">
				<div className="on-boarding-box box">
					<h3 className="page-title">{"All Done!"}</h3>
					<div>
						<Link to={this.state.appKey ? `/apps/${this.state.appKey}` : "/"} className="btn btn-primary">
							{"Let's Start Building"}
						</Link>
					</div>
				</div>
			</div>
		);
	};

	render() {
		const { step } = this.state;
		return (
			<div className="log-in-window">
				<div className="log-in-window-content">
					<div className={`on-boarding-step ${step > 0 ? "on" : ""} ${step > 1 ? "out" : ""}`}>
						{step > 0 && this.renderAppBuilder()}
					</div>
					<div className={`on-boarding-step ${step > 1 ? "on" : ""} ${step > 2 ? "out" : ""}`}>
						{step > 1 && this.renderThemeBuilder()}
					</div>
					<div className={`on-boarding-step ${step > 2 ? "on" : ""} ${step > 3 ? "out" : ""}`}>
						{step > 2 && this.renderExperienceBuilder()}
					</div>
					<div className={`on-boarding-step ${step > 3 ? "on" : ""} ${step > 4 ? "out" : ""}`}>
						{step > 3 && this.renderFinish()}
					</div>
					<div className={`on-boarding-step ${step > 4 ? "on" : ""} ${step > 5 ? "out" : ""}`}>
						{step > 4 && this.renderChecklist()}
					</div>
					<div className={`on-boarding-step ${step > 5 ? "on" : ""} ${step > 6 ? "out" : ""}`}>
						{step > 5 && this.renderDone()}
					</div>
				</div>
			</div>
		);
	}
}
OnBoarding.propTypes = {
	match: PropTypes.any,
	timezones: PropTypes.any,
	history: PropTypes.any,
	lookupsActions: PropTypes.object,
	appsActions: PropTypes.object,
	user: PropTypes.object,
};

function mapStateToProps(state) {
	return {
		auth: state.auth,
		timezones: state.controlPanel.timezones,
		cultures: state.cultures.cultures,
		user: state.user.user,
	};
}

const mapDispatchToProps = dispatch => ({
	lookupsActions: bindActionCreators(lookupsActions, dispatch),
	appsActions: bindActionCreators(appsActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OnBoarding);
